import {Service} from '@angular/core';

@Service()
export class SabrService {

  // private urlBase = environment.serviceUrl;
  //
  // constructor(
  //   private http: HttpClient,
  //   private googleService: GoogleService,
  //   private personLoginService: PersonLoginService
  // ) {
  // }
  //
  // public getSabrSummary(folderNumber: string, entityId: string, customerId: string): Observable<SabrSummary> {
  //   let brandID = this.personLoginService.getBrandIDs();
  //   let url = this.urlBase + 'sabrSummary/' + folderNumber + '/' + entityId + '/' + customerId + '/' + brandID;
  //   return this.http.get<SabrSummary>(url, {headers: this.getRequestHeaders()});
  // }
  //
  // public downloadInvoiceDocument(company: string, invoiceNumber: number): Observable<Blob> {
  //   let url = this.urlBase + 'sabrSummary/invoice/pdf/' + company + '/' + invoiceNumber;
  //   return this.http.get(url, {
  //     headers: this.getRequestHeaders(),
  //     observe: 'response',
  //     responseType: 'blob'
  //   }).pipe(map((response: any) => {
  //     return new Blob([response.body], {type: response.headers.get('Content-Type')});
  //   }));
  // }
  //
  // private getRequestHeaders(): HttpHeaders {
  //   return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  // }

}
